import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { ShareIt } from "../../../../../constants";
import { ProductSocialLinks } from "../../../../../data/applications/ECommerce";

// A component that displays social media icons for sharing the product.
const SocialLinks = () => {

  return (
    <Row className="py-1">
      <Col md="4">
        <h4>{ShareIt}</h4>
      </Col>
      <Col md="8">
        <div>
          <ul className="product-social">
            {ProductSocialLinks.map((item, index) => (
              <li className="d-inline-block" key={index}>
                <Link to={item.link} target="_blank">
                  <i className={item.text}></i>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </Col>
    </Row>
  );
};
export default SocialLinks;